<template>
  <main class="about-us">
    <ShopTypeBlock />
    <div class="about-section-list">
      <AboutSection
        v-for="sec in sections"
        :key="sec.title"
        :sectionTitle="sec.sectionTitle"
        :title="sec.title"
        :content="sec.content"
        :img="sec.img"
        :imgAlt="sec.imgAlt"
        :imgWidth="sec.imgWidth"
        :imgPosition="sec.imgPosition"
        :bg="sec.bg"
        :titleBg="sec.titleBg"
        :imgClass="sec.imgClass"
      >
        <template #content>
          <div v-if="sec.id === 1">
            LINE 、Google 預約，24H 接單不中斷，<br />
            免人工接洽，讓美業經營者專注服務顧客，<br />
            還能線上預收訂金，是美業必備神助手！
          </div>

          <div v-if="sec.id === 2">
            用 APP 就能查看顧客預約、美業老師排班，<br />
            後台還能用 AI 分析績效、預測熱門預約時段，<br />
            數位化管理店務大小事，店務營運更輕鬆！
          </div>

          <div v-if="sec.id === 3">
            設計會員制度，深度經營會員培養回頭客，<br />
            用儲值優惠、生日禮、滿額贈刺激消費，<br />
            還有好友推薦活動，鼓勵舊客帶新客！
          </div>
          <div v-if="sec.id === 4">
            設計美業包套優惠，線上、線下皆可銷售，<br />
            顧客購買完成，發放電子票券到 LINE 帳戶，<br />
            資訊透明、即時更新，不怕人工紙本混亂。
          </div>
          <div v-if="sec.id === 5">
            一站式美業平台，輕鬆管理所有旗下分店，<br />
            人員分潤自動計算、統整顧客消費數據，<br />
            讓你掌握全局，優化美業經營策略！
          </div>
        </template>
      </AboutSection>
    </div>

    <VideoIntro class="px-[25px]" />
    <ShopPartnerBlock />
    <PlanLinkBlock />

    <PageFooterSolgan>
      讓美業歐巴 LINE 預約系統<br />
      幫您管理預約、多元行銷，有感提升營收！
    </PageFooterSolgan>
  </main>
</template>

<script setup>
import ShopTypeBlock from './components/ShopTypeBlock.vue'
import AboutSection from './components/AboutSection.vue'
import VideoIntro from './components/VideoIntro.vue'
import ShopPartnerBlock from './components/ShopPartnerBlock.vue'
import PlanLinkBlock from './components/PlanLinkBlock.vue'
import reservation from '@/assets/aboutUs/reservation.png'
import lottery from '@/assets/aboutUs/lottery.png'
import dashboard from '@/assets/aboutUs/dashboard.png'
import { useMeta } from 'vue-meta'
import { formatSeoMeta } from '@/utils/seo'
import PageFooterSolgan from '@/components/PageFooterSolgan.vue'
import { computed } from 'vue'

import img1 from '@/assets/aboutUs/2025/feature_1.webp'
import img2 from '@/assets/aboutUs/2025/feature_2.webp'
import img3 from '@/assets/aboutUs/2025/feature_3.webp'
import img4 from '@/assets/aboutUs/2025/feature_4.webp'
import img5 from '@/assets/aboutUs/2025/feature_5.webp'

const imgWidth = '386px'

const sections = computed(() => [
  {
    id: 1,
    sectionTitle: '美業預約系統',
    title: '24H 接單，線上預約平台',
    img: img1,
    imgPosition: 'left',
    imgWidth,
    imgAlt: '24H 接單，線上預約平台',
  },
  {
    id: 2,
    sectionTitle: '美業數位轉型',
    title: '數位經營，美業管店 APP',
    img: img2,
    imgPosition: 'right',
    imgWidth,
    imgAlt: '數位經營，美業管店 APP',
  },
  {
    id: 3,
    sectionTitle: '打造穩定客源',
    title: '美業行銷，刺激收入成長',
    img: img3,
    imgPosition: 'left',
    imgWidth,
    imgAlt: '美業行銷，刺激收入成長',
  },
  {
    id: 4,
    sectionTitle: '美業包套課程',
    title: '票券系統，管理包套票券',
    img: img4,
    imgPosition: 'right',
    imgWidth,
    imgAlt: '票券系統，管理包套票券',
  },
  {
    id: 5,
    sectionTitle: '美業店務管理',
    title: '店務管理，掌握經營狀況',
    img: img5,
    imgPosition: 'left',
    imgWidth,
    imgAlt: '店務管理，掌握經營狀況',
    imgClass: '<desktop:mt-[-5%]',
  },
])

const metas = formatSeoMeta({
  title: '美業歐巴｜LINE 預約系統 x 會員系統－威許移動－美業 No.1',
  description:
    '美業預約系統推薦「美業歐巴」服務！透過「預約系統、會員系統」幫助美業 ( 美容、美甲、美髮 ) 提升業績！無論是美容預約系統、美甲預約系統、美髮預約系統、醫美管理系統，專業服務交給你，其他交給美業歐巴！結合 LINE 預約系統、LINE 會員系統，讓您的美業生意無往不利。',
})

useMeta(metas)
</script>

<style scoped lang="postcss">
.about-us {
  @apply m-auto;
}

.about-section-list {
  @apply mt-[12px] flex flex-col
  @apply tablet: (mt-[52px]);
}

.solgan {
  @apply text-[17px] font-bold leading-[1.2] tracking-[1px]  py-[20px];
  @apply tablet: (pt-[56px] pb-[32px] text-[48px] leading-[69.5px] tracking-[2px]);
}
</style>
